import { types } from 'mobx-state-tree';
import WagerList from './WagerList';

const BetSlipStoreModel = types.model('BetSlipStore', {
    WagerList: types.optional(WagerList, { wagers: [] }),
    betSlipVisible: types.boolean
})
    .actions(self => ({
        resetStore() {
            self.WagerList = {};
        },
        showHideBetSlip() {
            self.betSlipVisible = !self.betSlipVisible;
            //console.log(self.betSlipVisible)
        },
        showBetSlip() {
            self.betSlipVisible = true;
            //console.log(self.betSlipVisible)
        },
        hideBetSlip() {
            self.betSlipVisible = false;
            //console.log(self.betSlipVisible)
        }
    }))
    .views((self) => ({
        getBetSlipStatus(){
            return self.betSlipVisible;
        }
    }));

const BetSlipStore = BetSlipStoreModel.create({
    WagerList: {},
    betSlipVisible: false,
});

export default BetSlipStore;


// WEBPACK FOOTER //
// ./src/stores/BetSlipStore/BetSlipStore.js